<template>
  <!-- 评委信息管理 -->
  <div class="judgesInfo">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query" placeholder="请输入考场名称" style="width: 200px; margin-right:10px" @keyup.enter.native="tableLoad" @clear="
            query.query = '';
            tableLoad();
          " clearable suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button size="small" @click="tableLoad">查询</el-button>
        </Debounce>
        <el-select v-model="query.examSiteId" style="margin-left: 10px" @change="tableLoad" filterable placeholder="请选择">
          <el-option label="全部关联市代" value=""></el-option>
          <el-option v-for="item in examSiteList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-button type="primary" size="small" v-if="$roleFilter('room:add')" @click="operatInfo(1)">添加</el-button>
      <FileOperatDropdown @reLoad="tableLoad" style="margin:0px 10px;" :roles="[$roleFilter('room:templete'),$roleFilter('room:import')]" :uploadUrl="'/examRoom/import'" :downloadUrl="'/examRoom/download'" :exportUrl="'/examRoom/export'" :exportData="query" :butText="['下载模板','导入考场','导出考场']" />
      <el-button type="danger" size="small" v-if="$roleFilter('room:delete')" @click="operatInfo(0)">删除</el-button>
    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;" :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中" @selection-change="handleSelectionChange" :height="$store.getters.getTableHeight">
      <el-table-column type="selection" align="center" width="50"></el-table-column>
      <el-table-column prop="examRoomName" label="考场" align="center"></el-table-column>
      <el-table-column prop="linkExamSiteName" label="关联市代" align="center"></el-table-column>
      <el-table-column prop="examRoomAddr" label="考场地点" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="tableContentUpdateBut" size="small" v-if="$roleFilter('room:update')" @click="operatInfo(2, scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content" @pagination="tableLoad" />
    <el-dialog custom-class="dailogComponents" :title="visibleType == 1 ? '添加' : '修改'" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="400px">
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>考场:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.examRoomName" placeholder="请输入内容"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>关联市代:</p>
          </el-col>
          <el-col :offset="1">
            <el-select v-model="visibleObj.examSiteId" style="width: 100%" @change="tableLoad" filterable placeholder="请选择">
              <el-option v-for="item in examSiteList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="7">
            <p><span style="color:red;">*</span>考场地点:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.examRoomAddr"  type="textarea" :rows="2" placeholder="请输入内容"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="7">
            <el-button size="medium" @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <Debounce>
              <el-button size="medium" type="primary" @click="submit">确认</el-button>
            </Debounce>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileOperatDropdown from '@/views/admin/components/FileOperatDropdown'

export default {
  //考场信息管理
  name:'examRoomManagement',
  components: {
    FileOperatDropdown,
  },
  data() {
    return {
      tableList: [],
      tableSelectList: [],
      tableIsLoad: true,
      examSiteList: [],
      visible: false,
      visibleType: 0, //删除
      visibleObj: {
        linkExamSiteId: [], //关联市代
        examRoomName: '', //考场名称
        examRoomAddr: "", //考场地点
        examSiteId:'',
      },
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        examSiteId:'',//关联市代
      },
    };
  },
  mounted() {
    this.tableLoad();
    this.getAllSelectList()
  },
  methods: {
    tableLoad() {
      this.$axios.post("/examRoom", this.query).then((res) => {
        console.log(res);
        let {
          list,
          total
        } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    handleSelectionChange(val) {
      this.tableSelectList = val;
    },
    operatInfo(type, row) {
      if(type===1){
        this.visibleObj={
          linkExamSiteId: [], //关联市代
          examRoomName: '', //考场名称
          examRoomAddr: "", //考场地点
          examSiteId:'',
          examRoomId:'',
        }
        this.visibleType=type;
        this.visible=true;
      }else if(type===2){
        this.visibleObj={
          linkExamSiteId: row.linkExamSiteId, //关联市代
          examRoomName: row.examRoomName, //考场名称
          examRoomAddr: row.examRoomAddr, //考场地点
          examRoomId:row.examRoomId,
          examSiteId:row.linkExamSiteId[0] || '',
        }
        this.visibleType=type;
        this.visible=true;
      }else if(type===0){
        if(this.tableSelectList.length===0){
          this.$message.warning('请选择数据进行操作！')
          return
        }
        let ids = this.tableSelectList.map(item=>item.examRoomId)
        this.$dailog({
          title: "删除",
          context: "是否删除所选择的数据?",
          callbackFun: () => {
            this.$axios.delete("/examRoom",{
              data:ids,
            }).then((res) => {
              this.$message.success('删除成功！')
              this.tableLoad()
            });
          },
        });
      }
    },
    getAllSelectList(){
      this.$axios.get("/examRoom/select").then((res) => {
        let data = res.data.data;
        this.examSiteList=data.map(item=>{
          item.value*=1;
          return item;
        });
      });
    },
    submit(){
      if(
          !this.visibleObj.examSiteId||
          !this.visibleObj.examRoomAddr ||
          !this.visibleObj.examRoomName
      ){
        this.$message.warning('请填写完整数据再提交！')
        return
      }
      this.visibleObj.linkExamSiteId=[this.visibleObj.examSiteId]
      this.$axios({
        method:this.visibleType===1?'post':'put',
        url:this.visibleType===1?'/examRoom/add':'/examRoom',
        data:this.visibleObj,
      }).then(res=>{
        this.$message.success(this.visibleType===1?'添加成功！':'修改成功！')
        this.tableLoad()
        this.visible=false;
      })
    }
  },
};
</script>
